import API from '../../functions/api';

const PARTNERS_CONTENT_LOADED = 'partners/content/loaded';
const PARTNERS_CONTENT_REQUESTED = 'partners/content/requested';

export function requestPartnerData(slug) {
    return (dispatch) => {
        if (!slug || slug === undefined) {
            return null;
        }

        dispatch({
            type: PARTNERS_CONTENT_REQUESTED,
            slug,
        });

        return API.get(`/partners/${slug}`)
        .then((res) => {
            dispatch({
                type: PARTNERS_CONTENT_LOADED,
                data: res.data,
                slug: slug,
                status: 200
            });
            return Promise.resolve();
        })
        .catch((error) => {
            // console.log(`Couldn't get partner:`, error);
            dispatch({
                type: PARTNERS_CONTENT_LOADED,
                data: {},
                slug: slug,
                status: error.response.status
            });
            return Promise.resolve({status: error.response.status});
        });
    };
}

const defaultContentState = {};

export default function partners(state = defaultContentState, action) {
    switch (action.type) {
    case PARTNERS_CONTENT_REQUESTED:
        return Object.assign({}, state, {
            [action.slug]: {
                isFetching: true,
            },
        });
    case PARTNERS_CONTENT_LOADED:
        return Object.assign({}, state, {
            [action.slug]: {
                isFetching: false,
                hasLoaded: true,
                status: action.status,
                ...action.data,
            },
        });
    default:
        return state;
    }
}
